import get from 'lodash/get';
import set from 'lodash/set';

function replacePicUrl(picUrl) {
  if (picUrl && picUrl.indexOf('img-photo') > -1) {
    let picData = picUrl.split('?');
    let basePicUrl = picData[0];
    let query = picData[1] || '';
    let crop = query.match(/crop\/(.*)\/fw/g);

    if (crop && crop[0]) {
      return `${basePicUrl}?imageView2/1/w/400/h/400/q/75`;
    }

    return picUrl;
  }

  return picUrl;
}

/**
 * 生成假的房间用户数
 * @param {Number} count 房间用户数
 */
const fakeCount = (count = 0) => {
  let unit = '';
  let fakeCount = 0;

  switch (true) {
    case count < 20:
      count = count * 100;
      break;
    case count < 50:
      count = count * 80;
      break;
    default:
      count = count * 68;
      break;
  }

  count += Math.round(Math.random() * 100);

  if (count >= 10000) {
    fakeCount = parseFloat((count / 10000).toFixed(2), 10);
    unit = '万';
    // } else if (count >= 1000) {
    //     fakeCount = parseFloat((count / 1000).toFixed(2), 10);
    //     unit = '千';
  } else {
    fakeCount = count;
  }

  return {
    visiter_count: `${count}${unit}`,
    count,
    fakeCount,
    unit,
  };
};
/**
 * 生成假的主播房间人数
 * @param {Array} list 主播数据列表
 */
function fakeListVisiterCount(list = []) {
  return list.map((item) => {
    let { app_pic_url } = item;

    app_pic_url = replacePicUrl(app_pic_url);

    return _.assign(item, fakeCount(item.visiter_count || 0), { app_pic_url });
  });
}

function changePkListPic(list) {
  return list.map((item) => {
    let { detail } = item;

    set(detail, '0.app_pic_url', replacePicUrl(get(detail, '0.app_pic_url')));
    set(detail, '1.app_pic_url', replacePicUrl(get(detail, '1.app_pic_url')));

    item.detail = detail;

    return item;
  });
}

export default {
  fakeCount,
  fakeListVisiterCount,
  changePkListPic,
  replacePicUrl,
};
